import {
  changeContactFormField,
  changeCustomContactFormField,
  loadContactForm,
} from '@actions/agentconsole';
import { getGeneralProperties } from '@actions/common';
import { fetchContactById } from '@src/reducers/contactRToolkit';
import {
  getActiveChatContactInfo,
  linkedPhoneSelector,
} from '@src/selectors/contact';
import { activeChatSelector } from '@src/selectors/chats';
import { connect } from 'react-redux';
import ContactViewer from './ContactViewer';

const mapStateToProps = state => {
  const activeChat = activeChatSelector(state);
  const contact = activeChat?.contact;
  const contactBotId = activeChat?.botId;

  const countriesDataSet = state?.generalProperties?.arrCountries ?? [];
  const customFormFields = [];
  if (state.agentConsole.customForm) {
    const { customForm } = state.agentConsole;
    Object.keys(customForm).forEach(key => {
      const { value } = customForm[key];
      customFormFields.push({ attrId: key, value });
    });
  }

  return {
    contact,
    contactBotId,
    contactInfo: getActiveChatContactInfo(state),
    linkedPhone: linkedPhoneSelector(state),
    chatId: activeChat?.id,
    provider: activeChat?.provider,
    viaBotAccountId: activeChat?.viaBotAccountId,
    citiesDataSet: state.citiesDataSet,
    contactForm: state.agentConsole.contactForm,
    customForm: customFormFields,
    countriesDataSet,
    isLoggingOut: state.agentConsole.backendConn.isLoggingOut,
    notifications: state.adminHome.contact.notifications,
  };
};

const mapDispatchToProps = {
  onChangeContactFormField: changeContactFormField,
  onChangeCustomContactFormField: changeCustomContactFormField,
  getGeneralProperties,
  loadContactForm,
  fetchContactById,
};

const ContactViewerContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactViewer);

export default ContactViewerContainer;
